import { createStore } from 'vuex';

import { application } from './application';
import { auth } from './auth';
import { childEntities } from './childEntities';
import { notes } from './notes';
import { eoi } from './eoi';
import { ui } from './ui';
import { notifications } from './notifications';
import { settings } from './settings';
import { claim } from './claim';

const store = createStore({
  modules: {
    application,
    auth,
    childEntities,
    notes,
    eoi,
    ui,
    notifications,
    settings,
    claim
  }
});

export default store;
